<div class="document-list">
  <div class="toolbar">
    <div class="search-box">
      <input
        type="text"
        class="search-input"
        placeholder="Buscar documento..."
        [ngModel]="searchTerm()"
        (ngModelChange)="onSearchChange($event)" />
    </div>

    <div class="segmented">
      <button
        type="button"
        class="segmented-option"
        [class.active]="filterType() === 'Todos'"
        (click)="setFilterType('Todos')">
        Todos
      </button>
      <button
        type="button"
        class="segmented-option"
        [class.active]="filterType() === 'Faturamento'"
        (click)="setFilterType('Faturamento')">
        Faturamento
      </button>
      <button
        type="button"
        class="segmented-option"
        [class.active]="filterType() === 'Dre'"
        (click)="setFilterType('Dre')">
        DRE
      </button>
      <button
        type="button"
        class="segmented-option"
        [class.active]="filterType() === 'Balanco'"
        (click)="setFilterType('Balanco')">
        Balanço
      </button>
    </div>

    <app-select
      class="status-select"
      theme="clean"
      placeholder="Todos os status"
      selectedItemsLabel="{0} status"
      [multiple]="true"
      [maxSelectedLabels]="1"
      [options]="statusOptions"
      [ngModel]="filterStatuses()"
      (ngModelChange)="onStatusFilterChange($event)" />

    <app-select
      class="year-select"
      theme="clean"
      placeholder="Todos os anos"
      selectedItemsLabel="{0} anos"
      [multiple]="true"
      [maxSelectedLabels]="1"
      [options]="yearOptions()"
      [ngModel]="yearSelectValues()"
      (ngModelChange)="onYearFilterChange($event)" />

    <div class="segmented layout-segmented">
      <button
        type="button"
        class="segmented-option"
        [class.active]="layout() === 'tabela'"
        (click)="setLayout('tabela')">
        Tabela
      </button>
      <button
        type="button"
        class="segmented-option"
        [class.active]="layout() === 'cards'"
        (click)="setLayout('cards')">
        Cards
      </button>
    </div>

    <app-button
      class="reprocess-btn"
      icon="pi pi-sync"
      severity="secondary"
      size="small"
      [fitContent]="true"
      [disabled]="selectedCount() === 0"
      [label]="'Extrair selecionados (' + selectedCount() + ')'"
      [isLoading]="isReprocessing()"
      loadingText="Enviando..."
      title="Re-extrai apenas os documentos selecionados (status Não extraído ou Erro)"
      (sendClick)="onReprocessSelected()" />
  </div>

  <div class="count-label">{{ countLabel() }}</div>

  @if (isLoading()) {
    <div class="loading-state">
      <app-cog-loading-spinner [size]="80" />
    </div>
  } @else if (documents().length === 0) {
    <div class="empty-state">Nenhum documento encontrado com esses filtros.</div>
  } @else if (layout() === 'tabela') {
    <div class="document-table" [class.with-company]="showCompanyColumn()">
      <div class="table-header">
        <div class="cell-check"></div>
        @if (showCompanyColumn()) {
          <button
            type="button"
            class="sort-header"
            [attr.aria-sort]="ariaSort('Empresa')"
            (click)="onSort('Empresa')">
            Empresa <i class="pi" [ngClass]="sortIcon('Empresa')"></i>
          </button>
        }
        <button
          type="button"
          class="sort-header"
          [attr.aria-sort]="ariaSort('Documento')"
          (click)="onSort('Documento')">
          Documento <i class="pi" [ngClass]="sortIcon('Documento')"></i>
        </button>
        <button
          type="button"
          class="sort-header"
          [attr.aria-sort]="ariaSort('Periodo')"
          (click)="onSort('Periodo')">
          Período <i class="pi" [ngClass]="sortIcon('Periodo')"></i>
        </button>
        <button
          type="button"
          class="sort-header"
          [attr.aria-sort]="ariaSort('Status')"
          (click)="onSort('Status')">
          Status <i class="pi" [ngClass]="sortIcon('Status')"></i>
        </button>
        <div>Situação na análise</div>
        <button
          type="button"
          class="sort-header"
          [attr.aria-sort]="ariaSort('Enviado')"
          (click)="onSort('Enviado')">
          Enviado em <i class="pi" [ngClass]="sortIcon('Enviado')"></i>
        </button>
        <button
          type="button"
          class="sort-header"
          [attr.aria-sort]="ariaSort('EnviadoPor')"
          (click)="onSort('EnviadoPor')">
          Enviado por <i class="pi" [ngClass]="sortIcon('EnviadoPor')"></i>
        </button>
        <button
          type="button"
          class="sort-header"
          [attr.aria-sort]="ariaSort('Processado')"
          (click)="onSort('Processado')">
          Processado <i class="pi" [ngClass]="sortIcon('Processado')"></i>
        </button>
        <div></div>
      </div>

      @for (doc of documents(); track doc.id) {
        <div
          class="table-row"
          [class.table-row--period-covered]="isPeriodCovered(doc)"
          (click)="onSelect(doc)">
          <div class="cell-check" (click)="$event.stopPropagation()">
            @if (selectable(doc)) {
              <input
                type="checkbox"
                [checked]="isSelected(doc)"
                (change)="toggleSelect(doc, $event)" />
            }
          </div>
          @if (showCompanyColumn()) {
            <div class="cell-company" [title]="companyLabel(doc)">{{ companyLabel(doc) }}</div>
          }
          <div class="cell-document">
            <span class="type-icon" [ngClass]="iconClass(doc)">
              {{ iconLetter(doc) }}
            </span>
            <!-- Tipo do documento como subtítulo do nome (card 3700): a coluna "Situação na análise" precisava
                 do espaço da antiga coluna Tipo. O filtro de tipo continua na barra de cima. -->
            <span class="doc-name-block">
              <span class="doc-name" [title]="doc.name">{{ doc.name }}</span>
              <span class="doc-type-subtitle">{{ typeLabel(doc) }}</span>
            </span>
          </div>
          <div class="cell-period">{{ doc.period }}</div>
          <div class="cell-status">
            <span
              class="status-chip"
              [ngClass]="statusClass(doc.status)"
              [pTooltip]="statusTooltip(doc)"
              tooltipPosition="top"
              tooltipStyleClass="diagnostics-tooltip"
              [tooltipDisabled]="!statusTooltip(doc)"
              >{{ statusLabel(doc.status) }}</span
            >
            @if (hasProgressPercent(doc)) {
              <app-accounting-progress-percent
                class="progress-label progress-percent"
                [summary]="doc.progress"
                data-testid="progress-percent" />
            } @else if (progressText(doc); as text) {
              <span
                class="progress-label"
                [pTooltip]="progressTooltip(doc)"
                tooltipPosition="top"
                tooltipStyleClass="diagnostics-tooltip"
                data-testid="progress-label"
                >{{ text }}</span
              >
            } @else if (deParaBadge(doc); as badge) {
              <span
                class="depara-badge"
                [ngClass]="badge.cssClass"
                [pTooltip]="badge.tooltip"
                tooltipPosition="top"
                tooltipStyleClass="diagnostics-tooltip"
                >{{ badge.label }}</span
              >
            }
            @if (showDiagnosticIcon(doc)) {
              <i
                class="diag-icon pi"
                role="img"
                tabindex="0"
                [ngClass]="[diagnosticIconClass(doc), diagnosticIcon(doc)]"
                [attr.aria-label]="diagnosticIconAriaLabel(doc)"
                [pTooltip]="statusTooltip(doc) || 'Ver diagnóstico da extração no documento'"
                tooltipPosition="top"
                tooltipStyleClass="diagnostics-tooltip"></i>
            }
          </div>
          <div class="cell-situation">
            <app-document-analysis-situation
              [situation]="doc.analysisSituation"
              (coveredOpened)="onOpenCovered(doc, $event)"
              (reviewRequested)="onSelect(doc)" />
          </div>
          <div class="cell-submitted-at">{{ submittedAtLabel(doc) }}</div>
          <div class="cell-submitted-by" [title]="submittedByLabel(doc)">
            {{ submittedByLabel(doc) }}
          </div>
          <div class="cell-processed">{{ formatDateTime(doc.processedAt) }}</div>
          <div class="cell-chevron">›</div>
        </div>
      }
    </div>
  } @else {
    <div class="cards-grid">
      @for (doc of documents(); track doc.id) {
        <div
          class="doc-card"
          [class.doc-card--period-covered]="isPeriodCovered(doc)"
          (click)="onSelect(doc)">
          <div class="card-top">
            <span class="type-icon" [ngClass]="iconClass(doc)">
              {{ iconLetter(doc) }}
            </span>
            <span
              class="status-chip"
              [ngClass]="statusClass(doc.status)"
              [pTooltip]="statusTooltip(doc)"
              tooltipPosition="top"
              tooltipStyleClass="diagnostics-tooltip"
              [tooltipDisabled]="!statusTooltip(doc)"
              >{{ statusLabel(doc.status) }}</span
            >
            @if (!progressText(doc)) {
              @if (deParaBadge(doc); as badge) {
                <span
                  class="depara-badge"
                  [ngClass]="badge.cssClass"
                  [pTooltip]="badge.tooltip"
                  tooltipPosition="top"
                  tooltipStyleClass="diagnostics-tooltip"
                  >{{ badge.label }}</span
                >
              }
            }
            @if (showDiagnosticIcon(doc)) {
              <i
                class="diag-icon pi"
                role="img"
                tabindex="0"
                [ngClass]="[diagnosticIconClass(doc), diagnosticIcon(doc)]"
                [attr.aria-label]="diagnosticIconAriaLabel(doc)"
                [pTooltip]="statusTooltip(doc) || 'Ver diagnóstico da extração no documento'"
                tooltipPosition="top"
                tooltipStyleClass="diagnostics-tooltip"></i>
            }
          </div>
          @if (selectable(doc)) {
            <label class="card-check" (click)="$event.stopPropagation()">
              <input
                type="checkbox"
                [checked]="isSelected(doc)"
                (change)="toggleSelect(doc, $event)" />
            </label>
          }
          <div class="card-name" [title]="doc.name">{{ doc.name }}</div>
          <div class="card-meta">
            @if (showCompanyColumn()) {
              {{ companyLabel(doc) }} ·
            }
            {{ typeLabel(doc) }} · {{ doc.period }}
          </div>
          @if (hasProgressPercent(doc)) {
            <app-accounting-progress-percent
              class="progress-label progress-label--card progress-percent"
              [summary]="doc.progress" />
          } @else if (progressText(doc); as text) {
            <div
              class="progress-label progress-label--card"
              [pTooltip]="progressTooltip(doc)"
              tooltipPosition="top"
              tooltipStyleClass="diagnostics-tooltip">
              {{ text }}
            </div>
          }
          @if (doc.analysisSituation) {
            <app-document-analysis-situation
              class="card-situation"
              [situation]="doc.analysisSituation"
              (coveredOpened)="onOpenCovered(doc, $event)"
              (reviewRequested)="onSelect(doc)" />
          }
          <div class="card-footer">
            <span class="submitted">
              Enviado {{ submittedAtLabel(doc) }} por {{ submittedByLabel(doc) }}
            </span>
            <span class="processed">Processado {{ formatDateTime(doc.processedAt) }}</span>
          </div>
        </div>
      }
    </div>
  }

  <!--
    O rodapé aparece sempre que há documentos, mesmo com uma única página: o seletor de linhas por
    página precisa continuar acessível para o usuário aumentar/diminuir o corte. Só a navegação
    numerada some quando não há mais de uma página.
  -->
  @if (documents().length > 0 && !isLoading()) {
    <div class="pagination">
      @if (pages() > 1) {
        <nav class="pager" aria-label="Paginação de documentos">
          <button
            type="button"
            class="pager-btn"
            title="Primeira página"
            aria-label="Primeira página"
            [disabled]="page() <= 1"
            (click)="goToPage(1)">
            <i class="pi pi-angle-double-left"></i>
          </button>
          <button
            type="button"
            class="pager-btn"
            title="Página anterior"
            aria-label="Página anterior"
            [disabled]="page() <= 1"
            (click)="goToPage(page() - 1)">
            <i class="pi pi-angle-left"></i>
          </button>

          @for (pageNumber of visiblePages(); track pageNumber) {
            <button
              type="button"
              class="pager-btn pager-page"
              [class.active]="pageNumber === page()"
              [attr.aria-current]="pageNumber === page() ? 'page' : null"
              [attr.aria-label]="'Página ' + pageNumber"
              (click)="goToPage(pageNumber)">
              {{ pageNumber }}
            </button>
          }

          <button
            type="button"
            class="pager-btn"
            title="Próxima página"
            aria-label="Próxima página"
            [disabled]="page() >= pages()"
            (click)="goToPage(page() + 1)">
            <i class="pi pi-angle-right"></i>
          </button>
          <button
            type="button"
            class="pager-btn"
            title="Última página"
            aria-label="Última página"
            [disabled]="page() >= pages()"
            (click)="goToPage(pages())">
            <i class="pi pi-angle-double-right"></i>
          </button>
        </nav>
      }

      <app-select
        class="page-size-select"
        theme="clean"
        title="Linhas por página"
        [options]="pageSizeOptions"
        [ngModel]="pageSizeValue()"
        (ngModelChange)="onPageSizeChange($event)" />
    </div>
  }
</div>
